export default __webpack_public_path__ + "static/media/navbar-white-list-orange.1bd11d84.svg";